export const envConfig = {
    deployType: process.env.VUE_APP_DEPLOY_TYPE,
    cdnUrl: process.env.VUE_APP_CDN_URL,
    formalServer: process.env.VUE_APP_FORMAL_SERVER,
    remoteSVNServiceUrl: 'http://8.130.32.232:9001',
    svnIp: '8.130.32.232',
    storageServiceUrl: process.env.VUE_APP_STORAGE_SERVICE_URL,
    testServer: 'https://server.cottongame.com',
    imServer: process.env.VUE_APP_IM_SERVER
}
